jQuery(document).ready(function(){

$("a[href='#']").click(function(e) {
     e.preventDefault();
   document.querySelector('.landing_page_product').scrollIntoView({ 
  behavior: 'smooth' 
})
});

  
jQuery('.ingredient_toggle').click(function(){
var current_tab = $(this).attr('data-tab');
jQuery('.custom_ingredient_toggle').slideToggle();
jQuery('.custom_ingredient_toggle_button').toggle();
});


$("a[href='#reviews']").click(function(e) {
     e.preventDefault();
   document.querySelector('#reviews').scrollIntoView({ 
  behavior: 'smooth' 
})
});
jQuery('.custom_button').click(function(){
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});


jQuery('.video_wrapper_custom.video-active').click(function(){
    var video = jQuery(this).find('video');
var videoElement = video.get(0);
if (videoElement.paused) {
   jQuery(this).removeClass('video-active');
    jQuery(this).find('.custom_button').removeClass('active');
video.trigger('pause');
}  else {
}

});


jQuery('.question_product,.faq_question').click(function(){
 if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
 } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
 }
});



function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.section6_ul ul li').each(function () {
        if (isScrolledIntoView(this) === true) {
            $(this).addClass('in_viewport');
        } else {
          $(this).removeClass('in_viewport');
        }
    });

});













});



